import React from 'react';
import {
  Checkbox,
  FormControl,
  FormControlLabel,
  FormGroup,
  FormLabel,
} from '@mui/material';
import { makeStyles } from '@mui/styles';
import { Controller } from 'react-hook-form';

const coarsePointer = '@media (hover: none) and (pointer: coarse)';

const useStyles = makeStyles((theme) => ({
  fieldset: {
    width: '100%',
    minWidth: 0,
    marginBottom: theme.spacing(1.25),
    maxHeight: `min(${theme.spacing(62.5)}, 60vh)`,
    overflow: 'auto',
  },
  legend: { marginBottom: theme.spacing(1.25) },
  option: {
    marginRight: 0,
    alignItems: 'flex-start',
  },
  optionLabel: {
    minWidth: 0,
    overflowWrap: 'anywhere',
    paddingTop: theme.spacing(1.125),
    [coarsePointer]: { paddingTop: theme.spacing(1.25) },
  },
  checkbox: {
    [coarsePointer]: { padding: theme.spacing(1.25) },
  },
}));

const ListPermissions = ({ label, permissions, control, kind }) => {
  const classes = useStyles();

  return (
    <FormControl component="fieldset" className={classes.fieldset}>
      <FormLabel className={classes.legend} component="legend">
        {label}
      </FormLabel>
      <FormGroup>
        {permissions.map((perm) => (
          <Controller
            key={`${kind}-${perm.code}`}
            name="permissions"
            control={control}
            render={({ field }) => {
              const { value = [], onChange } = field;

              const isChecked = value.some((p) => p.element === perm.code && p.kind === kind);

              const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
                if (event.target.checked) {
                  onChange([...value, { kind, element: perm.code }]);
                } else {
                  onChange(value.filter((p) => !(p.element === perm.code && p.kind === kind)));
                }
              };

              return (
                <FormControlLabel
                  classes={{ root: classes.option, label: classes.optionLabel }}
                  control={
                    <Checkbox
                      checked={isChecked}
                      onChange={handleChange}
                      color="secondary"
                      className={classes.checkbox}
                    />
                  }
                  label={perm.description}
                />
              );
            }}
          />
        ))}
      </FormGroup>
    </FormControl>
  );
};

export default ListPermissions;
